import React from "react";

const LaptopSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="42.225"
      height="33.78"
      viewBox="0 0 42.225 33.78"
    >
      <path
        fill="#fff"
        d="M41.169 27.446h-16a2.08 2.08 0 01-2.16 2.111H19a2.24 2.24 0 01-2.162-2.111H1.056A1.059 1.059 0 000 28.5v1.056a4.235 4.235 0 004.223 4.224H38a4.235 4.235 0 004.223-4.223V28.5a1.059 1.059 0 00-1.054-1.054zM38 3.167A3.176 3.176 0 0034.836 0H7.389a3.176 3.176 0 00-3.166 3.167v22.168H38zm-4.22 17.946H8.445V4.223H33.78z"
      ></path>
    </svg>
  );
};

export default LaptopSVG;
